import { EnumActionsTypesPI, ActionsTypes } from './personalInfo.types';
import { DataPersonalInfoState, initialState } from './personalInfo.state';

export const PersonalInfoReducer = (
  state = initialState,
  action: ActionsTypes,
): DataPersonalInfoState => {
  switch (action.type) {
    case EnumActionsTypesPI.SET_PERSON: {
      return {
        ...state,
        person: {
          ...state.person,
          ...action.payload,
        },
      };
    }
    case EnumActionsTypesPI.SET_DATA_PROPERTY: {
      return {
        ...state,
        person: {
          ...state.person,
          [action.payload.name]: action.payload.value,
        },
      };
    }
    case EnumActionsTypesPI.FETCH_REQUESTS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case EnumActionsTypesPI.FETCH_FAILURE: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case EnumActionsTypesPI.FETCH_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case EnumActionsTypesPI.BACK_INITIAL_STATE: {
      return {
        ...initialState,
      };
    }
    case EnumActionsTypesPI.SET_REDUX_STATE: {
      return {
        ...action.payload,
      };
    }
    default:
      return { ...state };
  }
};
